var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6172,
    cy: 12,
    r: 11.375,
    fill: "white",
    fillOpacity: 0.2,
    stroke: "white",
    strokeWidth: 1.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13161_12165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6155 6.02344C11.2925 6.02489 10.024 6.55107 9.08847 7.48655C8.1529 8.42203 7.62659 9.6904 7.625 11.0134C7.625 12.2984 8.62 14.3094 10.5825 16.9904C10.8161 17.3105 11.122 17.5709 11.4753 17.7504C11.8286 17.9299 12.2192 18.0234 12.6155 18.0234C13.0118 18.0234 13.4024 17.9299 13.7557 17.7504C14.109 17.5709 14.4149 17.3105 14.6485 16.9904C16.611 14.3094 17.606 12.2984 17.606 11.0134C17.6044 9.6904 17.0781 8.42203 16.1425 7.48655C15.207 6.55107 13.9385 6.02489 12.6155 6.02344ZM12.6155 13.0024C12.2199 13.0024 11.8333 12.8851 11.5044 12.6654C11.1755 12.4456 10.9191 12.1332 10.7677 11.7678C10.6164 11.4023 10.5768 11.0002 10.6539 10.6123C10.7311 10.2243 10.9216 9.86792 11.2013 9.58822C11.481 9.30851 11.8374 9.11803 12.2253 9.04086C12.6133 8.96369 13.0154 9.0033 13.3809 9.15467C13.7463 9.30605 14.0587 9.56239 14.2784 9.89129C14.4982 10.2202 14.6155 10.6069 14.6155 11.0024C14.6155 11.5329 14.4048 12.0416 14.0297 12.4166C13.6546 12.7917 13.1459 13.0024 12.6155 13.0024Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13161_12165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6.61719 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationUser);
export default __webpack_public_path__ + "static/media/location-user.38b0ae3049985cc213e65d25e2607e87.svg";
export { ForwardRef as ReactComponent };